import { render, staticRenderFns } from "./CardModalChapter.vue?vue&type=template&id=4fe74e30&scoped=true&"
import script from "./CardModalChapter.vue?vue&type=script&lang=ts&"
export * from "./CardModalChapter.vue?vue&type=script&lang=ts&"
import style0 from "./CardModalChapter.vue?vue&type=style&index=0&id=4fe74e30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe74e30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
